export { default } from './DialButton';
